<template>
    <div class="thisweekarrangeplan">
        <el-row v-show="buttonShow" class="row-title">
            <!-- <el-col v-if="isMonitor" :span=2 style="margin-right:30px;"><kt-button :label="thisWeekArrangePlan.editorThisWeekSchedule" type="primary" @click="handleEditThisWeekPlan"/></el-col>
            <el-col v-if="isMonitor" :span=2 style="margin-right:30px;"><kt-button :label="thisWeekArrangePlan.addNextWeekSchedule" type="primary" @click="handleAddNextWeekPlan"/></el-col> -->
            <el-col :span=2 style="margin-right:30px;"><kt-button :label="thisWeekArrangePlan.editorThisWeekSchedule"
                    type="primary" @click="handleEditThisWeekPlan" /></el-col>
            <el-col :span=2 style="margin-right:30px;"><kt-button :label="thisWeekArrangePlan.addNextWeekSchedule"
                    type="primary" @click="handleAddNextWeekPlan" /></el-col>

            <el-col :span=2><kt-button :label="thisWeekArrangePlan.viewAllPlans" type="primary"
                    @click="handleLookAllPlan" /></el-col>
        </el-row>
        <el-row v-show="planShow" style="height:54px;line-height:54px;">
            <el-col :span=1 style="margin-right:5px;">{{ thisWeekArrangePlan.schedulingScheme }}</el-col>
            <el-col :span=4>
                <el-select v-model="plan" style="width:60%" @change="handleSelect" :disabled="planDisabled">
                    <el-option v-for="item in planOptions" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </el-col>
        </el-row>
        <el-row v-show="dateShow" style="height:54px;line-height:54px;">
            <el-col :span=2><kt-button label="返回" type="primary" @click="dateBack" /></el-col>
            <el-col :span=2 align=right style="margin-right:5px;">
                <kt-button label="上一周" type="primary" @click="handlePrevWeek" />
            </el-col>
            <el-col :span=4>
                <el-date-picker :editable="false" :clearable="false" v-model="dateValue" type="date"
                    :placeholder="thisWeekArrangePlan.optionDate" value-format="yyyy-MM-dd" format="yyyy-MM-dd"
                    @change="changeDate">
                </el-date-picker>
            </el-col>
            <el-col :span=2><kt-button label="下一周" type="primary" @click="handleNextWeek" /></el-col>
        </el-row>
        <el-row style="height:54px;line-height:54px;background:#F9F7FA;border:1px #F1EFF2 solid;margin-top:20px;">
            <el-col :span=4 style="font-size:18px;">
                <img src="@/assets/beadhouse/juxing.png" alt="" style="vertical-align:middle;margin:0 10px;">
                <span v-show="thisWeekPlanShow">{{ thisWeekArrangePlan.thisWeekSchedule }}</span>
                <span v-show="nextWeekPlanShow">{{ thisWeekArrangePlan.nextWeekSchedule }}</span>
                <span v-show="allPlanShow">{{ thisWeekArrangePlan.allSchedule }}</span>
            </el-col>
            <el-col :span=6 :offset=14 align=right><span style="margin-right:15px;">{{ week }}</span><span
                    style="margin-right:15px;">{{ whichWeekTo }}</span></el-col>
        </el-row>
        <el-row>
            <el-table style="width:100%" border :data="thisWeekArrangePlanList" :cell-class-name='getCellIndex'
                :row-style="tableRowStyle" :header-cell-style="tableHeaderColor" @cell-click="handleCellClick">
                <el-table-column label="" align="center" min-height="100" min-width="120" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <div>{{ scope.row.shift }}</div>
                        <div style="margin-left: 10px">{{ scope.row.time }}</div>
                    </template>
                </el-table-column>
                <el-table-column v-for='(temp, index) in labelList' :key="index" :label="temp" align="center"
                    min-height="100" min-width="100" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <div :class="{ 'hoverColor': isTrue }" v-if="index == 0">
                            <div style="margin-left: 10px;padding-top:5px;"
                                v-for="(item, index) in scope.row.monUserNameArray" :key="index">{{ item }}</div>
                        </div>
                        <div :class="{ 'hoverColor': isTrue }" v-else-if="index == 1">
                            <div style="margin-left: 10px;padding-top:5px;"
                                v-for="(item, index) in scope.row.tueUserNameArray" :key="index">{{ item }}</div>
                        </div>
                        <div :class="{ 'hoverColor': isTrue }" v-else-if="index == 2">
                            <div style="margin-left: 10px;padding-top:5px;"
                                v-for="(item, index) in scope.row.wedUserNameArray" :key="index">{{ item }}</div>
                        </div>
                        <div :class="{ 'hoverColor': isTrue }" v-else-if="index == 3">
                            <div style="margin-left: 10px;padding-top:5px;"
                                v-for="(item, index) in scope.row.thuUserNameArray" :key="index">{{ item }}</div>
                        </div>
                        <div :class="{ 'hoverColor': isTrue }" v-else-if="index == 4">
                            <div style="margin-left: 10px;padding-top:5px;"
                                v-for="(item, index) in scope.row.friUserNameArray" :key="index">{{ item }}</div>
                        </div>
                        <div :class="{ 'hoverColor': isTrue }" v-else-if="index == 5">
                            <div style="margin-left: 10px;padding-top:5px;"
                                v-for="(item, index) in scope.row.satUserNameArray" :key="index">{{ item }}</div>
                        </div>
                        <div :class="{ 'hoverColor': isTrue }" v-else-if="index == 6">
                            <div style="margin-left: 10px;padding-top:5px;"
                                v-for="(item, index) in scope.row.sunUserNameArray" :key="index">{{ item }}</div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="status clearfix">
                <div class="status-left">{{ thisWeekArrangePlan.status }}</div>
                <div class="status-right">{{ status }}</div>
            </div>
            <div align="center" style="margin:40px 0 50px 0" v-show="saveAndBackShow">
                <kt-button label="确定" type="primary" @click="submitPlan" />
                <kt-button label="返回" type="warning" @click="back" />
            </div>
        </el-row>
        <!-- 点击表格的单个单元格弹出dialog模态框-->
        <el-dialog :title="thisWeekArrangePlan.add" width="45%" :visible.sync="dialogVisibleAddNursing"
            :close-on-click-modal="false" @close="closeAddNursing">
            <el-form :model="addNursing" label-width="100px" :rules="addNursingRules" ref="addNursing"
                label-position="right">
                <el-row style="width:80%;margin:0 auto;">
                    <el-row
                        style="height:54px;line-height:54px;border:1px #F1EFF2 solid;text-align:center;font-size:16px;">{{ thisWeekArrangePlan.careManagement }}</el-row>
                    <el-row style="min-height:100px;border:1px #F1EFF2 solid;border-top:none;">
                        <el-checkbox-group v-model="checkedNursing" @change="handleCheckedNursing"
                            style="width:65%;margin:10px auto;">
                            <el-checkbox v-for="(nursing, i) in allNursing" :label="nursing.value" :key="i"
                                style="margin-top:10px;">{{ nursing.label }}</el-checkbox>
                        </el-checkbox-group>
                    </el-row>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer" align="center">
                <el-button :size="size" @click.native="handleCancel">取消</el-button>
                <el-button :size="size" type="primary" @click.native="submitFormAddNursing"
                    :loading="addNursingLoading">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import KtTable from "@/components/KtTable"
import KtButton from "@/components/KtButton"
import util from '@/utils/util.js'
export default {
    name: "ThisWeekArrangePlan",
    components: { KtTable, KtButton },
    data() {
        return {
            isMonitor: false, //是否是班长
            planDisabled: true,//排班方案下拉框是否禁用 true   false
            loading: false,
            status: "",//审批状态
            nursingGroupId: "",
            thisWeekArrangePlan: {
                which: "第",
                week: "周",
                to: "至",
                Monday: "周一",
                Tuesday: "周二",
                Wednesday: "周三",
                Thursday: "周四",
                Friday: "周五",
                Saturday: "周六",
                Sunday: "周日",
                editorThisWeekSchedule: "编辑本周排班",
                addNextWeekSchedule: "添加下周排班",
                viewAllPlans: "查看全部计划",
                schedulingScheme: "排班方案",
                optionDate: "选择日期",
                thisWeekSchedule: "本周排班计划",
                nextWeekSchedule: "下周排班计划",
                thisMonSchedule: "本月排班计划",
                nextMonSchedule: "下月排班计划",

                allSchedule: "所有排班计划",
                loading: "拼命加载中...",
                status: "状态",
                approvalPending: "待审批",
                add: "添加",
                careManagement: "护工列表",
                schedulingPlan: "排班计划",
                operation: "操作",
                confirmationInformation: "信息确认",
                noPassTitle: "你确定不通过排班计划吗?",
                reason: "原因",
                notEmpty: "不能为空",
                messageLen: "长度在 1到 50 的字符"
            },//引入 lang 里面的字符串资源,
            week: "",//第几周
            whichWeekTo: "",//某某年月日到某某年月日
            Monday: "",
            Tuesday: "",
            Wednesday: "",
            Thursday: "",
            Friday: "",
            Saturday: "",
            Sunday: "",
            monUserNameArray: [],
            tueUserNameArray: [],
            wedUserNameArray: [],
            thuUserNameArray: [],
            friUserNameArray: [],
            satUserNameArray: [],
            sunUserNameArray: [],
            isTrue: false,//点击表格的单元格时是否有 hoverColor的样式属性
            cellClickWeek: "",//点击表格的单元格是星期几
            size: 'medium',//按钮的尺寸
            dateShow: false,
            dateValue: util.formatDate.format(new Date(), 'yyyy-MM-dd'),
            thisWeekPlanShow: true,
            nextWeekPlanShow: false,
            allPlanShow: false,
            buttonShow: true,
            planShow: false,
            plan: "",//排班方案下拉框的值
            planOptions: [],
            checkScheduleList: [],//用来判断本周的排班计划是否存在
            thisWeekArrangePlanList: [],//table表格的数据
            labelList: [],
            saveAndBackShow: false,
            //添加护工的dialog配置
            dialogVisibleAddNursing: false,
            addNursing: {},
            addNursingRules: {},
            addNursingLoading: false,
            checkedNursing: [],//被选中的护工集合
            allNursing: [],//所有护工的集合
            scheduls: [],//排班几划的集合
            checkUserId: "",//护工id拼接的字符串
            checkRealName: "",//护工名字的字符串拼接
            columnLabel: "",//table每一列的label
            rowShiftsId: "",//table每一行的shiftsId
            userNameArray: [],//点击填充表格的护工名数组
            rowIndex: "",//by guo 2019-12-09-17:15添加
            columnIndex: "",//by guo 2019-12-09-17:15添加
        }
    },
    methods: {

        /* 
            判断是否为班长 不是班长不能编辑 by xiang 2019-11-28
        */
        findIsMonitor() {
            this.$postForm("omc/group/getUserLongDetail").then(res => {
                this.isMonitor = res.result.monitor;
                if (!this.isMonitor) {
                    this.$message({
                        message: "非班长用户不能编辑排班计划",
                        type: "error"
                    });
                }
            });
        },
        /* 
            编辑本周排班
        */
        handleEditThisWeekPlan() {
            this.planDisabled = (this.checkScheduleList != null && this.checkScheduleList.length > 0) ? true : false;//判断this.checkScheduleList存在 就为true不可选取  否则可以选取
            this.thisWeekPlanShow = true;
            this.nextWeekPlanShow = false;
            this.allPlanShow = false;
            this.buttonShow = false;
            this.planShow = true;
            this.saveAndBackShow = true;
            this.isTrue = true;
            this.labelList = [];//把数据清空
            this.getWeekHtml();
            //this.queryScheduleList();
            //by guo 2019-8-19  14:36修改
            this.judgeScheduleList();
            setTimeout(() => {
                this.queryScheduleList();
            }, 500)
        },

        /*
            添加下周排班
        */
        handleAddNextWeekPlan() {
            this.planDisabled = false;
            this.nextWeekPlanShow = true;
            this.thisWeekPlanShow = false;
            this.allPlanShow = false;
            this.buttonShow = false;
            this.planShow = true;
            this.saveAndBackShow = true;
            if (this.checkScheduleList != null && this.checkScheduleList.length > 0) {//判断 排班计划是否存在  存在采取获取  否则不获取
                this.getOnePlan(this.plan);
            }
            this.isTrue = true;
            this.labelList = [];//把数据清空

            var doday = new Date();
            console.log(doday)
            doday = Date.parse(doday);
            console.log(doday);
            // 将当前日期加上7天的时间
            doday = doday + (1000 * 60 * 60 * 24 * 7);
            // timeFormat()日期格式化
            var nowDate = util.formatDate.format(new Date(doday));
            console.log(nowDate)
            this.labelList = [];//清空数据
            let dayarr = nowDate.split("-");
            if (dayarr.length == 3) {
                this.week = this.getWeekNumber(nowDate);
                this.getWeekUI(nowDate);
            }
            this.judgeScheduleList();
            setTimeout(() => {
                this.queryScheduleList();
            }, 500)
        },

        /* 
            查看全部计划
        */
        handleLookAllPlan() {
            this.allPlanShow = true;
            this.thisWeekPlanShow = false;
            this.nextWeekPlanShow = false;
            this.buttonShow = false;
            this.dateShow = true;
            this.isTrue = false;
            this.labelList = [];//把数据清空
            this.getWeekAndDateHtml();
            //this.queryScheduleList();
            //by guo 2019-8-19  14:36修改
            this.judgeScheduleList();
            setTimeout(() => {
                this.queryScheduleList();
            }, 500)
        },

        /*
            全部计划的页面返回
        */
        dateBack() {
            this.thisWeekPlanShow = true;
            this.nextWeekPlanShow = false;
            this.allPlanShow = false;
            this.buttonShow = true;
            this.planShow = false;
            this.saveAndBackShow = false;
            this.isTrue = false;
            this.dateShow = false;
            this.dateValue = util.formatDate.format(new Date(), 'yyyy-MM-dd');
            this.labelList = [];//把数据清空
            this.getWeekHtml();
            // this.queryScheduleList();
            //by guo 2019-8-19  14:36修改
            this.judgeScheduleList();
            setTimeout(() => {
                this.queryScheduleList();
            }, 500)
        },

        /*
            上一周
        */
        handlePrevWeek() {
            // 获得当前日期
            var doday = new Date(this.dateValue);
            console.log(doday)
            doday = Date.parse(doday);
            console.log(doday);
            // 将当前日期减去7天的时间
            doday = doday - (1000 * 60 * 60 * 24 * 7);
            // timeFormat()日期格式化
            var nowDate = util.formatDate.format(new Date(doday));
            console.log(nowDate)
            // 获得value
            this.dateValue = nowDate;
            console.log(this.dateValue);
            this.labelList = [];//清空数据
            let dayarr = this.dateValue.split("-");
            if (dayarr.length == 3) {
                this.week = this.getWeekNumber(this.dateValue);
                this.getWeekUI(this.dateValue);
            }
            this.judgeScheduleList();
            setTimeout(() => {
                this.queryScheduleList();
            }, 500)
        },

        /* 
            下一周
        */
        handleNextWeek() {
            // 获得当前日期
            var doday = new Date(this.dateValue);
            console.log(doday)
            doday = Date.parse(doday);
            console.log(doday);
            // 将当前日期加上7天的时间
            doday = doday + (1000 * 60 * 60 * 24 * 7);
            // timeFormat()日期格式化
            var nowDate = util.formatDate.format(new Date(doday));
            console.log(nowDate)
            // 获得value
            this.dateValue = nowDate;
            console.log(this.dateValue);
            this.labelList = [];//清空数据
            let dayarr = this.dateValue.split("-");
            if (dayarr.length == 3) {
                this.week = this.getWeekNumber(this.dateValue);
                this.getWeekUI(this.dateValue);
            }
            this.judgeScheduleList();
            setTimeout(() => {
                this.queryScheduleList();
            }, 500)
        },

        /* 
            点击时间查询 by xiang 
        */
        changeDate(val) {
            this.labelList = [];//清空数据
            let nowDate = util.formatDate.format(new Date(val));
            let dayarr = nowDate.split("-");
            console.log(dayarr)
            if (dayarr.length == 3) {
                this.week = this.getWeekNumber(val);
                this.getWeekUI(val);
            }
            this.judgeScheduleList();
            setTimeout(() => {
                this.queryScheduleList();
            }, 500)

        },

        /* 
            点击单个单元格
        */
        handleCellClick(row, column, cell, event) {
            this.columnLabel = column.label;
            this.rowShiftsId = row.shiftsId;
            this.rowIndex = row.index;//by guo 2019-12-09-17:11 添加
            this.columnIndex = column.index;//by guo 2019-12-09-17:11 添加
            console.log(this.rowIndex, this.columnIndex, '点击的是哪一行和那一列');
            console.log(this.allNursing, "-------------");
            //判断 hoverColor为true还是false,为true,  this.columnLabel!=''的时候才弹出dialog弹出框，为false 就不弹出
            if (this.isTrue == true && this.columnLabel != '') {
                console.log(row, column, cell, event);
                this.dialogVisibleAddNursing = true;
                console.log(row.monUserId, row.tueUserId, row.wedUserId, row.thuUserId, row.friUserId, row.satUserId, row.sunUserId)
                console.log(row.tueUserId.split('-'));
                let monUserId = row.monUserId.split('-');
                let tueUserId = row.tueUserId.split('-');
                let wedUserId = row.wedUserId.split('-');
                let thuUserId = row.thuUserId.split('-');
                let friUserId = row.friUserId.split('-');
                let satUserId = row.satUserId.split('-');
                let sunUserId = row.sunUserId.split('-');
                var reg = /[\u4e00-\u9fa5]/g;//中文正则
                let day = this.weeklyDays[cell.cellIndex - 1]
                this.cellClickdate = day.split("/").join("-")
                // console.log( this.weeklyDays[cell.cellIndex-1],"开始就会随粉红色的")
                this.cellClickWeek = this.columnLabel.match(reg).join("");//匹配中文
                // console.log(this.cellClickWeek);
                // this.cellClickWeek=this.cellClickWeek.join("");//拼接
                // console.log(this.cellClickWeek);
                // this.cellClickdate=this.columnLabel.replace(reg, "")
                // console.log(this.cellClickdate);
                //by guo 2019-11-02-12:40 修改  日期小于10需要处理，补0 否则会无法提交数据
                var dateList = this.cellClickdate.split('-');
                console.log(dateList);
                var year = dateList[0];
                var month = dateList[1];
                month = this.add0(month);
                var day2 = dateList[2];
                day2 = this.add0(day2);
                this.cellClickdate = year + "-" + month + '-' + day2;

                console.log(this.cellClickdate, "啥地方海事局肯定会发生的机会")
                //通过判断checkbox数据回显
                switch (this.cellClickWeek) {
                    case "周一":
                        this.checkedNursing = monUserId;
                        this.checkUserId = row.monUserId
                        this.checkRealName = row.monRealName
                        this.userNameArray = row.monUserNameArray;

                        break;
                    case "周二":
                        this.checkedNursing = tueUserId;
                        this.checkUserId = row.tueUserId
                        this.checkRealName = row.tueRealName
                        this.userNameArray = row.tueUserNameArray;

                        break;
                    case "周三":
                        this.checkedNursing = wedUserId;
                        this.checkUserId = row.wedUserId
                        this.checkRealName = row.wedRealName
                        this.userNameArray = row.wedUserNameArray;


                        break;
                    case "周四":
                        this.checkedNursing = thuUserId;
                        this.checkUserId = row.thuUserId
                        this.checkRealName = row.thuRealName
                        this.userNameArray = row.thuUserNameArray;


                        break;
                    case "周五":
                        this.checkedNursing = friUserId;
                        this.checkUserId = row.friUserId
                        this.checkRealName = row.friRealName
                        this.userNameArray = row.friUserNameArray;
                        break;
                    case "周六":
                        this.checkedNursing = satUserId;
                        this.checkUserId = row.satUserId
                        this.checkRealName = row.satRealName
                        this.userNameArray = row.satUserNameArray;
                        break;
                    default:
                        this.checkedNursing = sunUserId;
                        this.checkUserId = row.sunUserId
                        this.checkRealName = row.sunRealName
                        this.userNameArray = row.sunUserNameArray;
                }
            } else {
                this.dialogVisibleAddNursing = false;
            }
        },

        /* 
            dialog取消关闭
        */
        handleCancel() {
            console.log(this.plan);
            this.dialogVisibleAddNursing = false;
        },

        /* 
            返回按钮
        */
        back() {
            //提交数据后把所有的状态都初始化
            this.thisWeekPlanShow = true;
            this.nextWeekPlanShow = false;
            this.allPlanShow = false;
            this.buttonShow = true;
            this.planShow = false;
            this.saveAndBackShow = false;
            this.isTrue = false;
            this.labelList = [];//把数据清空
            this.getWeekHtml();
            //this.queryScheduleList();
            //by guo 2019-8-19  14:36修改
            this.judgeScheduleList();
            setTimeout(() => {
                this.queryScheduleList();
            }, 500)
        },

        /* 
            排班方案下拉框
        */
        handleSelect(value) {
            console.log(value);
            this.plan = value;//获取排班计划的id by guo 2019-12-17-19:09添加
            this.getOnePlan(value);
            setTimeout(() => {
                this.queryScheduleList();
            }, 100)
        },

        /* 
            获取单个排班方案
        */
        getOnePlan(id) {
            console.log(id, "id---------")
            let params = {};
            params.id = id;//id传0时是查询所有的
            this.thisWeekArrangePlanList = [];
            this.scheduls = [];
            this.loading = true;
            console.log(params, "传入的id是" + params.id);
            this.$postJson("omc/plan/queryListAll", params).then((res) => {
                console.log(res);
                res.result[0].shiftsList.forEach(temp => {
                    let schedulsObj = this.getSchedulsObj(temp);
                    let onePlanObj = this.getOnePlanObj(temp);
                    console.log(schedulsObj, onePlanObj, "################")
                    this.scheduls.push(schedulsObj);
                    this.thisWeekArrangePlanList.push(onePlanObj);
                })
                setTimeout(() => {
                    this.loading = false;
                }, 1000)
                console.log(this.thisWeekArrangePlanList, this.scheduls, "-------^^^^^")
            })
        },

        /* 
            获取需要提交的排班计划的数据   
        */
        getSchedulsObj(temp) {
            let schedulsObj = {};
            schedulsObj.planId = temp.planid * 1;
            schedulsObj.shiftsId = temp.id * 1;
            schedulsObj.week = (parseInt(this.weeklyDays[0]) + this.week.replace(/[^0-9]/ig, "")) * 1;
            schedulsObj.monDate = "";
            schedulsObj.monUserId = "";
            schedulsObj.monRealName = "";
            schedulsObj.tueDate = "";
            schedulsObj.tueUserId = "";
            schedulsObj.tueRealName = "";
            schedulsObj.wedDate = "";
            schedulsObj.wedUserId = "";
            schedulsObj.wedRealName = "";
            schedulsObj.thuDate = "";
            schedulsObj.thuUserId = "";
            schedulsObj.thuRealName = "";
            schedulsObj.friDate = "";
            schedulsObj.friUserId = "";
            schedulsObj.friRealName = "";
            schedulsObj.satDate = "";
            schedulsObj.satUserId = "";
            schedulsObj.satRealName = "";
            schedulsObj.sunDate = "";
            schedulsObj.sunUserId = "";
            schedulsObj.sunRealName = "";
            return schedulsObj;
        },

        /* 
            获取单个排班方案的数据
        */
        getOnePlanObj(temp) {
            let onePlanObj = {};
            onePlanObj.id = '';//排班id  修改提交数据需要
            onePlanObj.shift = temp.name;
            onePlanObj.time = '(' + temp.time + ')';
            onePlanObj.shiftsId = temp.id;
            onePlanObj.monDate = "";
            onePlanObj.monUserId = "";
            onePlanObj.monRealName = "";
            onePlanObj.monUserNameArray = [];
            onePlanObj.tueDate = "";
            onePlanObj.tueUserId = "";
            onePlanObj.tueRealName = "";
            onePlanObj.tueUserNameArray = [];
            onePlanObj.wedDate = "";
            onePlanObj.wedUserId = "";
            onePlanObj.wedRealName = "";
            onePlanObj.wedUserNameArray = [];
            onePlanObj.thuDate = "";
            onePlanObj.thuUserId = "";
            onePlanObj.thuRealName = "";
            onePlanObj.thuUserNameArray = [];
            onePlanObj.friDate = "";
            onePlanObj.friUserId = "";
            onePlanObj.friRealName = "";
            onePlanObj.friUserNameArray = [];
            onePlanObj.satDate = "";
            onePlanObj.satUserId = "";
            onePlanObj.satRealName = "";
            onePlanObj.satUserNameArray = [];
            onePlanObj.sunDate = "";
            onePlanObj.sunUserId = "";
            onePlanObj.sunRealName = "";
            onePlanObj.sunUserNameArray = [];
            return onePlanObj;
        },

        /* 
            获取全部排班方案
        */
        getArrangePlan(id) {
            let params = {};
            params.id = id;//id传0时是查询所有的
            this.planOptions = [];//先清空数据，防止累加
            this.$postJson("omc/plan/queryListAll", params).then((res) => {
                console.log(res);
                var plan = res.result;
                for (var i = 0; i < plan.length; i++) {
                    var item = {}
                    item.value = plan[i].id * 1;//需要转成Number类型
                    item.label = plan[i].name;
                    this.planOptions.push(item);//排班方案下拉框的数据源
                }
                //判断一下 排班计划是否存在  存在才默认选中
                console.log(this.checkScheduleList, "-------------")
                if (this.checkScheduleList != null && this.checkScheduleList.length > 0) {
                    //this.plan=plan[0].id;//排班方案select下拉框默认选中的值    //by guo 2019-8-13 19:21修改  有bug  不能默认选中第一个
                    this.getOnePlan(this.plan);//查询单个排班方案  下拉框默认选中的第一个
                }
            })
        },

        /* 
            获取某年某月某天是第几周   第一天为周一
        */
        getWeekNumber(data) {
            var today = new Date(data);
            var firstDay = new Date(today.getFullYear(), 0, 1);
            var dayOfWeek = firstDay.getDay();
            var spendDay = 1;
            if (dayOfWeek != 0) {
                spendDay = 7 - dayOfWeek + 1;
            }
            firstDay = new Date(today.getFullYear(), 0, 1 + spendDay);
            var d = Math.ceil((today.valueOf() - firstDay.valueOf()) / 86400000);
            var result = Math.ceil(d / 7);
            return result + 1;
        },

        /* 
            判断年份是否为润年
        */
        isLeapYear(year) {
            return (year % 400 == 0) || (year % 4 == 0 && year % 100 != 0);
        },

        /* 
            获取某年某月的天数 
        */
        getMonthDays(year, month) {
            return [31, (this.isLeapYear(year) ? 29 : 28), 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month - 1];
        },


        /*  *************** 本周排班计划 ***************  */

        /*  
            获取本周 周一是1,周日是7
        */
        getWeekDay(val) {
            var new_Date = new Date(val)
            var timesStamp = new_Date.getTime();
            var currenDay = new_Date.getDay();
            var dates = [];
            for (var i = 0; i < 7; i++) {
                dates.push(new Date(timesStamp + 24 * 60 * 60 * 1000 * (i - (currenDay + 6) % 7)).toLocaleDateString().replace(/[年月]/g, '-').replace(/[日上下午]/g, ''));
            }
            console.log(dates)
            this.weeklyDays = dates
        },

        /* 
            获取第几周  数据回显
        */
        getWeekHtml() {
            let today = new Date();//获取今天的时间
            today.setTime(today.getTime());
            let weekday = this.getWeekNumber(today);
            this.week = this.thisWeekArrangePlan.which + weekday + this.thisWeekArrangePlan.week;
            this.getWeekDay(today);
            this.getWeekAndDate(today);
        },

        /* 
            获取本周的星期和日期  数据回显
        */
        getWeekAndDate(today) {
            this.whichWeekTo = this.weeklyDays[0] + this.thisWeekArrangePlan.to + this.weeklyDays[6];
            console.log(this.whichWeekTo)
            this.Monday = this.thisWeekArrangePlan.Monday + this.weeklyDays[0];
            this.Tuesday = this.thisWeekArrangePlan.Tuesday + this.weeklyDays[1];
            this.Wednesday = this.thisWeekArrangePlan.Wednesday + this.weeklyDays[2];
            this.Thursday = this.thisWeekArrangePlan.Thursday + this.weeklyDays[3];
            this.Friday = this.thisWeekArrangePlan.Friday + this.weeklyDays[4];
            this.Saturday = this.thisWeekArrangePlan.Saturday + this.weeklyDays[5];
            this.Sunday = this.thisWeekArrangePlan.Sunday + this.weeklyDays[6];
            this.labelList.push(this.Monday, this.Tuesday, this.Wednesday, this.Thursday, this.Friday, this.Saturday, this.Sunday)
        },

        /* ************* 全部计划的 ********** */

        /* 
            获取第几周  获取下周的星期和日期 
        */
        getWeekUI(data) {
            let weekday = this.getWeekNumber(data);
            console.log(this.getWeekDay(data))
            this.week = this.thisWeekArrangePlan.which + weekday + this.thisWeekArrangePlan.week;
            this.whichWeekTo = this.weeklyDays[0] + this.thisWeekArrangePlan.to + this.weeklyDays[6];
            this.Monday = this.thisWeekArrangePlan.Monday + this.weeklyDays[0]
            this.Tuesday = this.thisWeekArrangePlan.Tuesday + this.weeklyDays[1]
            this.Wednesday = this.thisWeekArrangePlan.Wednesday + this.weeklyDays[2]
            this.Thursday = this.thisWeekArrangePlan.Thursday + this.weeklyDays[3]
            this.Friday = this.thisWeekArrangePlan.Friday + this.weeklyDays[4]
            this.Saturday = this.thisWeekArrangePlan.Saturday + this.weeklyDays[5]
            this.Sunday = this.thisWeekArrangePlan.Sunday + this.weeklyDays[6]
            this.labelList.push(this.Monday, this.Tuesday, this.Wednesday, this.Thursday, this.Friday, this.Saturday, this.Sunday)
        },

        /* 
            全部计划时间日期 数据回显
        */
        getWeekAndDateHtml() {
            let today = new Date();
            let nowDate = this.timeFormat(new Date().getTime())
            today.setTime(today.getTime());
            this.getWeekUI(nowDate);
        },

        /* 
            查询对应护工组的护工
        */
        selectAllNurse() {
            let params = {};
            params.pageNo = "1";
            params.pageSize = "999";
            params.nursingGroupId = this.nursingGroupId;//获取该护工组的护工
            console.log(params);
            this.allNursing = [];//请求数据之前先把数据置空
            this.$postJson('omc/group/selectById', params).then((res) => {
                console.log(res);
                if (res.code == 200) {
                    res.result.list.forEach((item, index) => {
                        console.log(item);
                        var allNursingObj = {};
                        allNursingObj.value = item.userId;
                        allNursingObj.label = item.realName;
                        this.allNursing.push(allNursingObj);
                    })
                } else {
                    //this.$message({message: res.message, type: 'error'}) 
                }
            })
        },


        /* 
            所有护工的checkbox选取
        */
        handleCheckedNursing(val) {
            console.log(val, this.allNursing);
            //去掉数组中空的字符 ""
            for (var i = 0; i < val.length; i++) {
                if (val[i] == "" || val[i] == null || val[i] == undefined) {
                    val.splice(i, 1);
                    i = i - 1;
                }
            }
            console.log(val);
            this.checkedNursing = val;
            // this.checkUserId=val.join('-');//by guo 2019-12-09-18:42注释

            this.checkUserId = '';//by guo 2019-12-09-18：43添加
            var checkUserIdList = [];//by guo 2019-12-09-18：43添加

            console.log(this.checkUserId);
            var checkRealName = '';//循环之前清空数据，防止累加
            this.userNameArray = [];//循环之前清空数据，防止累加

            this.checkedNursing.forEach(item => {
                console.log(item);
                this.allNursing.forEach(temp => {
                    if (item == temp.value) {
                        checkRealName += temp.label + '-';
                        this.userNameArray.push(temp.label);
                        checkUserIdList.push(temp.value);//by guo 2019-12-09-18：43添加
                    }
                })
            })
            console.log(checkUserIdList, "checkUserIdList");
            this.checkUserId = checkUserIdList.join('-');//by guo 2019-12-09-18：43添加
            this.checkRealName = checkRealName.substr(0, checkRealName.length - 1)
            console.log(this.checkRealName, this.userNameArray, this.checkUserId);
        },
        closeAddNursing() {
            //  this.userNameArray=[];
            //  this.checkRealName
        },
        /* 
            查询排班计划
        */
        queryScheduleList() {
            let params = {};
            console.log(this.week, "----^^^$$$$$$$");

            //跨年week值修改 by xiang 2019-12-26
            let weekDay = this.week.replace(/[^0-9]/ig, "")
            let weekFirst = parseInt(this.weeklyDays[6])
            console.log(weekDay, 'dsdssdssdsd')
            if (weekDay > 52) {
                weekDay = '1'
                weekFirst = parseInt(weekFirst)
            }
            params.week = (weekFirst + weekDay) * 1;
            params.nursingGroupId = this.nursingGroupId;

            console.log(params);
            this.$postJson('omc/schedule/queryScheduleList', params).then((res) => {
                console.log(res);
                console.log(this.thisWeekArrangePlanList);
                if (res.code == 200) {
                    if (res.result.length > 0) {
                        this.thisWeekArrangePlanList.forEach(item => {
                            console.log(item.shiftsId);
                            res.result.forEach(temp => {
                                console.log(temp.shiftsId, temp.planId, "planId")
                                if (item.shiftsId == temp.shiftsId) {
                                    item.id = temp.id;//排班Id  修改的时候提交数据需要
                                    item.monDate = temp.monDate;
                                    item.monUserId = temp.monUserId;
                                    item.monRealName = temp.monRealName;
                                    item.monUserNameArray = temp.monUserNameArray;
                                    item.tueDate = temp.tueDate;
                                    item.tueUserId = temp.tueUserId;
                                    item.tueRealName = temp.tueRealName;
                                    item.tueUserNameArray = temp.tueUserNameArray;
                                    item.wedDate = temp.wedDate;
                                    item.wedUserId = temp.wedUserId;
                                    item.wedRealName = temp.wedRealName;
                                    item.wedUserNameArray = temp.wedUserNameArray;
                                    item.thuDate = temp.thuDate;
                                    item.thuUserId = temp.thuUserId;
                                    item.thuRealName = temp.thuRealName;
                                    item.thuUserNameArray = temp.thuUserNameArray;
                                    item.friDate = temp.friDate;
                                    item.friUserId = temp.friUserId;
                                    item.friRealName = temp.friRealName;
                                    item.friUserNameArray = temp.friUserNameArray;
                                    item.satDate = temp.satDate;
                                    item.satUserId = temp.satUserId;
                                    item.satRealName = temp.satRealName;
                                    item.satUserNameArray = temp.satUserNameArray;
                                    item.sunDate = temp.sunDate;
                                    item.sunUserId = temp.sunUserId;
                                    item.sunRealName = temp.sunRealName;
                                    item.sunUserNameArray = temp.sunUserNameArray;
                                }
                                //by guo 2019-12-17-19-20添加   需要判断排班方案是否相同   相同并且存在排班计划才获取status的值 否则就为""
                                var reason = (temp.reason != null && temp.reason != undefined && temp.reason != '') ? temp.reason : '';
                                if (this.plan == temp.planId) {
                                    switch (temp.status) {
                                        case 0:
                                            this.status = "未审批";
                                            break;
                                        case 1:
                                            this.status = " 审批不通过" + "          原因：" + reason;
                                            break;
                                        default:
                                            this.status = "审批通过"
                                    }
                                } else {
                                    this.status = "";
                                }
                            })
                        })
                    } else {
                        console.log(this.checkScheduleList, "else-------")
                        // //判断排班计划是否存在 
                        // if(this.checkScheduleList!=null && this.checkScheduleList.length>0){
                        //     this.getOnePlan(this.plan);//重新获取数据
                        //     this.status="";//没有排班计划置空数据
                        // }else{
                        //     this.thisWeekArrangePlanList=[];//by guo 2019-8-13 20:03 添加
                        //     this.plan="";
                        //     this.status="";//没有排班计划置空数据
                        // }
                    }
                } else {
                    //this.$message({message: res.message, type: 'error'}) 
                }
                console.log(this.thisWeekArrangePlanList, "************^^^^****");
            })
        },

        /* 
            判断是否有判断计划 刚进来页面的提示
        */
        judgeScheduleList() {
            let params = {};
            //跨年week值修改 by xiang 2019-12-26
            let weekDay = this.week.replace(/[^0-9]/ig, "")
            let weekFirst = parseInt(this.weeklyDays[6])
            console.log(weekDay, 'dsdssdssdsd')
            if (weekDay > 52) {
                weekDay = '1'
                weekFirst = parseInt(weekFirst)
            }
            params.week = (weekFirst + weekDay) * 1;
            params.nursingGroupId = this.nursingGroupId;
            console.log(params);
            //params.week=(parseInt(this.whichWeekTo)+this.week.replace(/[^0-9]/ig,""))*1;
            params.nursingGroupId = this.nursingGroupId;
            console.log(params);
            this.checkScheduleList = [];//请求之前清空数据，防止数据累加
            this.$postJson('omc/schedule/queryScheduleList', params).then((res) => {
                console.log(res);
                this.checkScheduleList = res.result;//用来判断本周的排班计划是否存在
                if (res.code == 200) {
                    if (res.result === null) {
                        this.$message({ message: '暂无排班计划', type: 'error' })
                        this.thisWeekArrangePlanList = [];//by guo 2019-8-19 14:34 添加
                        this.plan = "";
                        this.status = "";//没有排班计划置空数据
                    } else {
                        this.thisWeekArrangePlanList = [];
                        /* by guo 2019-8-13 19:22 添加  获取当前的排班方案 用于下拉框的回显 */
                        for (var i = 0; i < res.result.length; i++) {
                            if (i == 0) {
                                this.plan = res.result[i].planId * 1;//获取planId 因为每一个planId都一样的，取第一个就可以了
                                break;//跳出循环，继续执行下面的代码
                            }
                        }
                    }
                } else {
                    this.$message({ message: res.message, type: 'error' })
                    this.thisWeekArrangePlanList = [];//by guo 2019-8-19 14:34 添加
                    this.plan = "";
                    this.status = "";//没有排班计划置空数据
                }
                console.log( "^^^^^^^^^^^^^^ 传0获取所有的");
                this.getArrangePlan(0);//传0获取所有的
                this.selectAllNurse();//查询所有的护工
            })
        },

        /* 
            添加护工提交缓存数据
        */
        submitFormAddNursing() {
            console.log('aaaa', this.cellClickWeek, this.rowShiftsId, this.cellClickdate);
            console.log(this.scheduls, this.thisWeekArrangePlanList);
            this.thisWeekArrangePlanList.forEach(item => {
                console.log(item);
                console.log(this.rowShiftsId == item.shiftsId)
                if (this.rowShiftsId == item.shiftsId) {
                    switch (this.cellClickWeek) {
                        case "周一":
                            item.monDate = this.cellClickdate;
                            item.monUserId = this.checkUserId;
                            item.monRealName = this.checkRealName;
                            item.monUserNameArray = this.userNameArray;
                            break;
                        case "周二":
                            item.tueDate = this.cellClickdate;
                            item.tueUserId = this.checkUserId;
                            item.tueRealName = this.checkRealName;
                            item.tueUserNameArray = this.userNameArray;
                            break;
                        case "周三":
                            item.wedDate = this.cellClickdate;
                            item.wedUserId = this.checkUserId;
                            item.wedRealName = this.checkRealName;
                            item.wedUserNameArray = this.userNameArray;
                            break;
                        case "周四":
                            item.thuDate = this.cellClickdate;
                            item.thuUserId = this.checkUserId;
                            item.thuRealName = this.checkRealName;
                            item.thuUserNameArray = this.userNameArray;
                            break;
                        case "周五":
                            item.friDate = this.cellClickdate;
                            item.friUserId = this.checkUserId;
                            item.friRealName = this.checkRealName;
                            item.friUserNameArray = this.userNameArray;
                            break;
                        case "周六":
                            item.satDate = this.cellClickdate;
                            item.satUserId = this.checkUserId;
                            item.satRealName = this.checkRealName;
                            item.satUserNameArray = this.userNameArray;
                            break;
                        default:
                            item.sunDate = this.cellClickdate;
                            item.sunUserId = this.checkUserId;
                            item.sunRealName = this.checkRealName;
                            item.sunUserNameArray = this.userNameArray;
                    }
                }
            })
            this.dialogVisibleAddNursing = false;
            console.log(this.thisWeekArrangePlanList, "______")
        },

        /* 
            添加排班计划和修改排班计划   需要判断是提交 还是修改  
        */
        submitPlan() {
            let params = {};
            params.nursingGroupId = this.nursingGroupId * 1;
            //跨年week值修改 by xiang 2019-12-26
            let weekDay = this.week.replace(/[^0-9]/ig, "")
            let weekFirst = parseInt(this.weeklyDays[6])
            console.log(weekDay, 'dsdssdssdsd')
            if (weekDay > 52) {
                weekDay = '1'
                weekFirst = parseInt(weekFirst)
            }
            params.week = (weekFirst + weekDay) * 1;
            // params.week=(parseInt(this.whichWeekTo)+this.week.replace(/[^0-9]/ig,""))*1;
            params.omcSchedulList = this.getScheduls();
            console.log(params);
            this.$postJson('omc/schedule/save', params).then((res) => {
                console.log(res)
                if (res.code == 200) {
                    this.$message({ message: '操作成功', type: 'success' })
                    this.dialogVisibleAddNursing = false;
                    //刷新页面 by xiang 
                    //提交数据后把所有的状态都初始化
                    this.thisWeekPlanShow = true;
                    this.nextWeekPlanShow = false;
                    this.allPlanShow = false;
                    this.buttonShow = true;
                    this.planShow = false;
                    this.saveAndBackShow = false;
                    this.isTrue = false;
                    this.labelList = [];//把数据清空
                    this.getWeekHtml();
                    this.judgeScheduleList();
                    setTimeout(() => {
                        this.queryScheduleList();
                    }, 500)
                } else {
                    this.$message({ message: '操作失败, ' + res.message, type: 'error' })
                }
                //提交数据后把所有的状态都初始化
                this.thisWeekPlanShow = true;
                this.nextWeekPlanShow = false;
                this.allPlanShow = false;
                this.buttonShow = true;
                this.planShow = false;
                this.saveAndBackShow = false;
                this.isTrue = false;
                this.labelList = [];//把数据清空
                this.getWeekHtml();
                this.queryScheduleList();
            })
        },

        /* 
            获取 需要提交的数据
        */
        getScheduls() {
            console.log(this.scheduls)
            this.scheduls.forEach(item => {
                console.log(item);
                console.log(this.thisWeekArrangePlanList)
                this.thisWeekArrangePlanList.forEach(temp => {
                    if (item.shiftsId == temp.shiftsId) {
                        if (temp.id == '') {//temp.id为空就是添加数据
                            item.monDate = temp.monDate;
                            item.monUserId = temp.monUserId;
                            item.monRealName = temp.monRealName;
                            item.tueDate = temp.tueDate;
                            item.tueUserId = temp.tueUserId;
                            item.tueRealName = temp.tueRealName;
                            item.wedDate = temp.wedDate;
                            item.wedUserId = temp.wedUserId;
                            item.wedRealName = temp.wedRealName;
                            item.thuDate = temp.thuDate;
                            item.thuUserId = temp.thuUserId;
                            item.thuRealName = temp.thuRealName;
                            item.friDate = temp.friDate;
                            item.friUserId = temp.friUserId;
                            item.friRealName = temp.friRealName;
                            item.satDate = temp.satDate;
                            item.satUserId = temp.satUserId;
                            item.satRealName = temp.satRealName;
                            item.sunDate = temp.sunDate;
                            item.sunUserId = temp.sunUserId;
                            item.sunRealName = temp.sunRealName;
                        } else {//修改数据
                            item.id = temp.id;//修改数据需要的排班id
                            item.monDate = temp.monDate;
                            item.monUserId = temp.monUserId;
                            item.monRealName = temp.monRealName;
                            item.tueDate = temp.tueDate;
                            item.tueUserId = temp.tueUserId;
                            item.tueRealName = temp.tueRealName;
                            item.wedDate = temp.wedDate;
                            item.wedUserId = temp.wedUserId;
                            item.wedRealName = temp.wedRealName;
                            item.thuDate = temp.thuDate;
                            item.thuUserId = temp.thuUserId;
                            item.thuRealName = temp.thuRealName;
                            item.friDate = temp.friDate;
                            item.friUserId = temp.friUserId;
                            item.friRealName = temp.friRealName;
                            item.satDate = temp.satDate;
                            item.satUserId = temp.satUserId;
                            item.satRealName = temp.satRealName;
                            item.sunDate = temp.sunDate;
                            item.sunUserId = temp.sunUserId;
                            item.sunRealName = temp.sunRealName;
                        }
                    }
                })
            })
            console.log(this.scheduls);
            return this.scheduls
        },

        /* 
            转换时间格式
        */
        timeFormat(timestamp) {
            //timestamp是整数，否则要parseInt转换,不会出现少个0的情况
            var time = new Date(timestamp);
            var year = time.getFullYear();
            var month = time.getMonth() + 1;
            var date = time.getDate();
            var hours = time.getHours();
            var minutes = time.getMinutes();
            var seconds = time.getSeconds();
            return year + '-' + this.add0(month) + '-' + this.add0(date)
        },

        /* 
            逢10补0
        */
        add0(m) {
            return m < 10 ? '0' + m : m
        },

        /* 
            *by guo 2019-12-09-17:12 添加
            *获取点击的表格行和列的索引 （row  column）
        */
        getCellIndex: function ({ row, column, rowIndex, columnIndex }) {
            row.index = rowIndex;
            column.index = columnIndex;
        },

        /* 
            修改table tr行的背景色
        */
        tableRowStyle({ row, rowIndex }) {
            if (rowIndex % 2 == 0) {
                return 'height:65px;'
            } else {
                return 'height:65px;'
            }
        },

        /* 
            修改table header的背景色
        */
        tableHeaderColor({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'background-color:#ccc;color:#6f7075;font-weight: 700;height:80px;'
            }
        },

    },
    created() {
        this.nursingGroupId = sessionStorage.getItem("nursingGroupId");//获取护工组id
        if (this.nursingGroupId == null || this.nursingGroupId == "" || this.nursingGroupId == "0" || this.nursingGroupId == " ") {
            //获取班组列表。选择默认第一个班组；
            // omc/group/selectShowAll
            this.$postJson('omc/group/selectShowAll', {}).then((res) => {
                console.log(res);
                this.nursingGroupId = res.result[0].id;
                sessionStorage.setItem("nursingGroupId", res.result[0].id);
                console.log(this.nursingGroupId);
            });
        }
        this.getWeekHtml();
    },
    mounted() {
        this.judgeScheduleList();
        //有bug  注释的代码移到this.judgeScheduleList()方法中去了   by guo 2019-08-13 19:29 修改
        //this.selectAllNurse();
        //延迟加载
        // setTimeout(()=>{
        //     this.getArrangePlan(0);//传0获取所有的
        // },500)
        setTimeout(() => {
            this.queryScheduleList();
        }, 1000)
        // this.findIsMonitor()
    },
}
</script>
<style lang="scss" scoped>
.thisweekarrangeplan {
    min-width: 1360px;
    min-height: 500px;
    background: #FEFEFE;

    .hoverColor {
        // height:65px;
        //by guo 2019-10-30-17:11 修改  样式应该给一个最小的高度  让每一行 每一列里面的数据能够自适应高度
        min-height: 40px;
        line-height: 20px;
    }

    .hoverColor:hover {
        background: rgb(153, 176, 206);
        cursor: pointer;
    }

    .status {
        width: 100%;
        height: 65px;
        border: 1px solid #EBEEF5;
        border-top: none;
        box-sizing: border-box;

        .status-left {
            width: 204px;
            height: 65px;
            line-height: 65px;
            text-align: center;
            border-right: 1px solid #EBEEF5;
            float: left;
        }

        .status-right {
            float: right;
            height: 65px;
            width: 1100px;
            max-width: 1154px;
            line-height: 65px;
            text-align: center;
        }
    }
}

//去除表格hover高亮
::v-deep .el-table--enable-row-hover .el-table__body tr:hover>td {
    background-color: #ffffff !important;
}

::v-deep .el-table .el-table__body td {
    padding: 0px !important;
}

::v-deep .el-table .cell {
    padding-left: 0 !important;
    padding-right: 0 !important;
}</style>
